import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { ButtonWithIcon } from '@blueprint/ui';

export const TextFieldWrapper = styled('div')(({ theme: { spacing } }) => {
    return css`
        margin-bottom: ${spacing['16px']};

        label {
            overflow: hidden;
            text-overflow: ellipsis;
            right: ${spacing['16px']};
        }
    `;
});

export const CallToActionRow = styled.div(
    () => css`
        display: flex;
        justify-content: flex-start;
        width: 100%;
    `
);

export const PropertyBlock = styled.div(
    ({ theme: { spacing } }) => css`
        margin-bottom: ${spacing['16px']};
    `
);

export const StyledButtonWithIcon = styled(ButtonWithIcon)(
    ({ theme: { mq } }) => css`
        width: 100%;

        ${mq.medium} {
            width: auto;
        }
    `
);
